module.exports = __webpack_public_path__ + "static/media/uniswap-v2.2ae3f49b.jpg";